// extracted by mini-css-extract-plugin
export var blogVariant = "styles-module--blogVariant--maGNY";
export var container = "styles-module--container--SCSbD";
export var title = "styles-module--title--lWbUT";
export var text = "styles-module--text--wdNk6";
export var videoContainer = "styles-module--videoContainer--7CRm4";
export var video = "styles-module--video--N5wB+";
export var backAndForthRight = "styles-module--backAndForthRight--gfb0w";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--K1KwW";
export var animateBg = "styles-module--animateBg--B3Yca";